import { AxiosResponse } from 'axios'
import { Page } from '../../../../types'

type FilterValue = Date | string | number | string[] | undefined

const toSafeString = (value: FilterValue | Date): string => {
  if (typeof value === 'undefined' || value === null) return ''

  switch (true) {
    case Array.isArray(value):
      return (value as any[]).map(toSafeString).join(',')
    case value instanceof Date:
      return (value as Date).toISOString()
    default:
      return value.toString()
  }
}

const applySearchParams = (url: URL, params: Record<string, FilterValue>) => {
  Object.entries(params).map(([key, value]) => {
    const safeValue = toSafeString(value)

    if (safeValue === '' || safeValue === undefined) {
      return
    }

    url.searchParams.set(key, toSafeString(value))
  })

  return url
}

const responseToPagination = <T extends unknown>({ data }: AxiosResponse): Page<T> => {
  const { data: items, meta } = data

  return { data: items, meta }
}

const urlToPathnameAndSearch = (url: URL | string) => {
  const placeholder = 'a.b.c'
  const newUrl = new URL(url)

  newUrl.hostname = placeholder

  return newUrl.href.split(newUrl.origin)[1]
}

export type { FilterValue }
export { applySearchParams, responseToPagination as responseToPage, urlToPathnameAndSearch }
